import { AxiosResponse } from 'axios'
import api from 'src/services/api'

export interface IBitrixUsuario {
  id: number
  nome: string
  email: string
  cargo: string
}

export const listarUsuariosBitrix = (): Promise<
  AxiosResponse<IBitrixUsuario[]>
> => {
  return api.get('/bitrix/usuarios')
}
